import React from 'react';
import { usePermissions } from '../hooks/usePermissions';

type CanProps = {
    /** Require this single permission. */
    permission?: string;
    /** Require at least one of these permissions. */
    anyOf?: string[];
    /** Require all of these permissions. */
    allOf?: string[];
    /** Rendered when the check fails (defaults to nothing). */
    fallback?: React.ReactNode;
    children: React.ReactNode;
};

/**
 * Conditionally renders children based on the current user's effective
 * permissions. UX affordance only — never the security boundary.
 */
const Can: React.FC<CanProps> = ({ permission, anyOf, allOf, fallback = null, children }) => {
    const { can, canAny, canAll } = usePermissions();

    let allowed = true;
    if (permission) allowed = allowed && can(permission);
    if (anyOf) allowed = allowed && canAny(anyOf);
    if (allOf) allowed = allowed && canAll(allOf);

    return <>{allowed ? children : fallback}</>;
};

export default Can;
